var vskoColorInput = angular.module('vskoColorInput', []);

vskoColorInput.directive('vskoColorInput', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-color-input.html'),
    scope: {

    }
  }
}]);
